module.exports = __webpack_public_path__ + "static/media/image-intro-desktop.8ac69ec7.jpg";